import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/image-to-video-ai"
    exact
    path="/consumer/features/image-to-video-ai"
    component={AsyncPage}
  />,
];
